import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import {
  ZoomIn,
  ZoomOut,
  FitScreen,
  Fullscreen,
  FullscreenExit,
} from "@mui/icons-material";

export const ViewerZoomToolbar = ({
  scale,
  onZoomIn,
  onZoomOut,
  onReset,
  isFullScreen,
  onToggleFullscreen,
}) => (
  <Box
    sx={{
      position: "absolute",
      bottom: 8,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 10,
      bgcolor: "rgb(230, 230, 230, 0.85)",
      borderRadius: "20px",
      px: 2,
      py: 0.5,
      display: "flex",
      alignItems: "center",
      gap: 3,
    }}
  >
    <Tooltip title="Zoom Out">
      <IconButton onClick={onZoomOut} size="small">
        <ZoomOut />
      </IconButton>
    </Tooltip>
    <Tooltip title="Zoom In">
      <IconButton onClick={onZoomIn} size="small">
        <ZoomIn />
      </IconButton>
    </Tooltip>
    <Typography variant="body2">{Math.round(scale * 100)}%</Typography>
    <Tooltip title="Reset Zoom">
      <IconButton onClick={onReset} size="small">
        <FitScreen />
      </IconButton>
    </Tooltip>
    <Tooltip title="Toggle Fullscreen">
      <IconButton onClick={onToggleFullscreen} size="small">
        {isFullScreen ? <FullscreenExit /> : <Fullscreen />}
      </IconButton>
    </Tooltip>
  </Box>
);

export const useViewerZoom = (initial = 1.0, min = 0.5, max = 2.0) => {
  const [scale, setScale] = React.useState(initial);
  return {
    scale,
    zoomIn: () => setScale((s) => Math.min(s + 0.1, max)),
    zoomOut: () => setScale((s) => Math.max(s - 0.1, min)),
    reset: () => setScale(initial),
  };
};

export const useViewerFullscreen = (containerRef) => {
  const [isFullScreen, setIsFullScreen] = React.useState(false);

  React.useEffect(() => {
    const handler = () => setIsFullScreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", handler);
    return () => document.removeEventListener("fullscreenchange", handler);
  }, []);

  const toggle = () => {
    const el = containerRef.current;
    if (!el) return;
    if (!document.fullscreenElement) {
      el.requestFullscreen().catch((err) =>
        console.error("Fullscreen error:", err)
      );
    } else {
      document.exitFullscreen();
    }
  };

  return { isFullScreen, toggle };
};
